<template>
<div tabindex="0" class="e-card">
  <div class="e-card-title">{{ pageTitle }}: Security Questions</div>
  <div class="e-card-content margin-color-verify-section">
      <div>
        <p v-if="verificationMessage" class="error-message" >{{ verificationMessage }}</p>
        <p v-else>
          In order to reset your password, we need to validate your account.
          Please answer the question what you provided during your accont set up.
        </p>
        <div class="e-float-input">
          <scc-input-validator
            :rules="[requiredRule]"
            :value="selectedQuestionId"
            @validate="v => this.isQuestionValid=v"
          >
            <ejs-dropdownlist
              float-label-type="Always"
              :data-source="currentQuestions"
              :fields="securityQuestionFields"
              v-model="selectedQuestionId"
              placeholder='Select a Question'>
            </ejs-dropdownlist>
          </scc-input-validator>
        </div>

        <scc-input-validator
          :rules="[requiredRule]"
          :value="currentAnswer"
          @validate="v => this.isAnswerValid=v"
        >
          <input-password ref="refPassword" v-model="currentAnswer"
                                    placeholder="Provide an Answer" />
          <!-- <ejs-textbox float-label-type="Auto"
            placeholder="Provide an Answer"
            type="password"
            v-model="currentAnswer" /> -->
        </scc-input-validator>

        <div class="align-center-bottom">
          <ejs-button type="submit"
                      cssClass="e-info margin-button"
                      :disabled="isUserLocked"
                      @click.native="onSubmitAnswer">
            Submit
          </ejs-button>
        </div>
      </div>
  </div>
</div>
</template>

<script>
import SccInputValidator from '@/components/base/scc-input-validator.vue';
import inputPassword from '../../../components/base/input-password.vue';

export default {
  name: 'SecurityQuestionsVarification',
  components: {
    SccInputValidator,
    inputPassword,
  },
  props: {
    pageTitle: {
      type: String,
      required: true,
    },
    securityQuestions: {
      type: Array,
      default() {
        return [];
      },
    },
    verificationMessage: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedQuestionId: null,
      currentQuestions: [],
      currentAnswer: null,
      answeredQuestions: [],
      securityQuestionFields: { text: 'question', value: 'id' },
      requiredRule: {
        regEx: '^(?!\\s*$).+',
        message: 'This field is required',
      },
      isAnswerValid: false,
      isQuestionValid: false,
      isUserLocked: false,
    };
  },
  methods: {
    onSubmitAnswer() {
      // trigger validation
      this.currentAnswer = this.isAnswerValid ? this.currentAnswer : '';
      this.selectedQuestionId = this.isQuestionValid ? this.selectedQuestionId : '';

      if (!this.isAnswerValid || !this.isQuestionValid) return;

      if (this.currentQuestions && this.currentQuestions.length > 0) {
        this.currentQuestions = this.currentQuestions.filter(
          (item) => item.id !== this.selectedQuestionId,
        );
        this.$emit('validateAnswer', { securityQuestionId: this.selectedQuestionId, answer: this.currentAnswer, questionCount: this.currentQuestions.length });
      }
    },
  },
  watch: {
    securityQuestions(newVal, oldVal) {
      this.currentQuestions = [];
      if ((newVal && newVal.length > 0) && !(oldVal && oldVal.length > 0)) {
        this.currentQuestions.push(...newVal);
      }
    },
  },
};
</script>

<style>
.e-card > .e-card-title {
  font-weight: 500;
  background: #0f4b90;
  color: white;
}
.e-card-content{
  text-align: left;
  /* margin: 5%; */
}
.margin-color-verify-section{
  margin: 2% !important;
  color: currentColor;
}
.margin-button {
  margin: 25px 5px 20px 20px;
}
.error-message {
  color: red;
}
.e-btn.e-info, .e-css.e-btn.e-info {
  background-color: #dba832 !important;
  color: white !important;
}
.align-center-bottom {
  display: block;
  text-align: center;
}
</style>
